import React from 'react';
import styled from 'styled-components';
import { colors, typography } from '../../../styles/theme';
import { ContentSection, SectionTitle, Grid, InfoCard, InfoLabel, InfoValue } from '../common/StyledComponents';

const InfoCardContent = styled.div`
  flex: 1;
`;

const InfoCardActions = styled.div`
  margin-left: 16px;
`;

const EditIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.5 3.5L20.5 7.5L7 21H3V17L16.5 3.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EditButton = styled.button`
  background: ${colors.primary}10;
  color: ${colors.primary};
  border: none;
  border-radius: 12px;
  width: 90px;
  height: 90px;
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.medium};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: ${colors.primary};
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
`;

const PolicyCoverage = ({ policyData, onEditCover }) => (
  <ContentSection>
    <SectionTitle>Coverage Details</SectionTitle>
    <Grid>
      <InfoCard withActions>
        <InfoCardContent>
          <InfoLabel>Coverage Limits</InfoLabel>
          <InfoValue>
            Aggregate: {policyData.limits.aggregate}<br />
            Per Claim: {policyData.limits.perClaim}
          </InfoValue>
        </InfoCardContent>
        <InfoCardActions>
          <EditButton onClick={onEditCover}>
            <EditIcon />
            Edit
          </EditButton>
        </InfoCardActions>
      </InfoCard>
      <InfoCard withActions>
        <InfoCardContent>
          <InfoLabel>Excess</InfoLabel>
          <InfoValue>
            General: {policyData.excess.general}<br />
          </InfoValue>
        </InfoCardContent>
        <InfoCardActions>
          <EditButton onClick={onEditCover}>
            <EditIcon />
            Edit
          </EditButton>
        </InfoCardActions>
      </InfoCard>
    </Grid>
  </ContentSection>
);

export default PolicyCoverage; 